module.exports = __webpack_public_path__ + "img/益视说明书_15.c3ec9a50.png";